export const RETAIL = 'Retail';
export const WHOLESALE = 'Wholesale';
export const IPO = 'IPO';
export const EOI = 'EOI';
